var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckMark2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 66.506,
    height: 56.788,
    viewBox: "0 0 66.506 56.788",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 57.464,
    height: 44.582,
    fill: "#95b13a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    "data-name": "Group 454",
    transform: "translate(-145.5 -4148.212)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(145.5 4150)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_12_-_Outline",
    "data-name": "Ellipse 12 - Outline",
    d: "M27.5,4a23.507,23.507,0,0,0-9.146,45.155A23.507,23.507,0,0,0,36.646,5.845,23.349,23.349,0,0,0,27.5,4m0-4A27.5,27.5,0,1,1,0,27.5,27.5,27.5,0,0,1,27.5,0Z",
    transform: "translate(145.5 4150)",
    fill: "#4f8c3e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(154.542 4148.212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M1.35,27.893c3.166,2.393,4.376,2.73,7.025,6.342,4.33,5.905,3.693,8.349,4.977,9.474s7.172,2.034,11.186-3.1,10.276-19.322,18.3-27.831S54.618,1.8,57.027.516,51.8-.5,36.8,11.435c-10.437,8.3-17.823,19.75-17.823,19.75a27.537,27.537,0,0,0-6.744-10.437C7.572,16.573-3.908,23.919,1.35,27.893",
    transform: "translate(0 0)",
    fill: "#95b13a"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark2);
export default __webpack_public_path__ + "static/media/check-mark_2.6deb2fa18199e61883e1360f1b334bf1.svg";
export { ForwardRef as ReactComponent };